// 9fbef606107a605d69c0edbcd8029e5d
/* This Code is copied from a library react-native-base64,
the reason is to not include a new package, and this code can be shared acorss web and app */

/* eslint-disable no-plusplus, no-bitwise, no-restricted-globals,
no-multi-assign, no-useless-escape, no-param-reassign, operator-assignment */
const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
export const encode = (input) => {
  const output = [];
  let chr1;
  let chr2;
  let chr3 = '';
  let enc1;
  let enc2;
  let enc3;
  let enc4 = '';
  let i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output.push(
      keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
    );
    chr1 = chr2 = chr3 = '';
    enc1 = enc2 = enc3 = enc4 = '';
  } while (i < input.length);

  return output.join('');
};

export const urlSafeEncode = (input) => {
  const output = encode(input);
  return output?.replace(/\+/g, '-')?.replace(/\//g, '_')?.replace(/=+$/g, '');
};

export const decode = (input) => {
  let output = '';
  let chr1;
  let chr2;
  let chr3 = '';
  let enc1;
  let enc2;
  let enc3;
  let enc4 = '';
  let i = 0;

  // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
  input = input?.replace(/[^A-Za-z0-9\+\/\=]/g, '');

  do {
    enc1 = keyStr.indexOf(input?.charAt(i++));
    enc2 = keyStr.indexOf(input?.charAt(i++));
    enc3 = keyStr.indexOf(input?.charAt(i++));
    enc4 = keyStr.indexOf(input?.charAt(i++));

    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;

    output = output + String.fromCharCode(chr1);

    if (enc3 !== 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 !== 64) {
      output = output + String.fromCharCode(chr3);
    }

    chr1 = chr2 = chr3 = '';
    enc1 = enc2 = enc3 = enc4 = '';
  } while (i < input?.length);

  return output;
};
